// extracted by mini-css-extract-plugin
export default {"p__rVieWrapper":"Layout_p__rVieWrapper__qoge6"};